import Lottie, { Options } from 'react-lottie';

import { dynamicStyling } from 'styles';

interface SVGAnimationProps extends Options {
  children?: never;
  className?: string;
  size?: number;
}

export function SVGAnimation({ className, animationData, size, ...options }: SVGAnimationProps) {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },

    ...options,
  };

  return (
    <div
      {...dynamicStyling({
        size,

        className,
      })}
    >
      <Lottie options={defaultOptions} />
    </div>
  );
}
